import styled from 'styled-components'
import { Colors, Typography } from 'cio-design-library/design-tokens'
import Media from 'builder/styles/media'

export const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 2px 0;
  height: 36px;

  ${Media.Phone`
    gap: 0;
    height: unset;
    flex-direction: column;
    align-items: flex-start;
  `}
`

export const NameContainer = styled.div`
  max-width: 193px;
  width: 100%;
`

export const NameText = styled.p`
  ${Typography.sizes.Caption};
  font-weight: ${Typography.weights.regular};
`

export const SliderContainer = styled.div`
  flex: 1;
`

export const TextValue = styled.p`
  ${Typography.sizes.Body};
  font-weight: ${Typography.weights.regular};
`

export const ValueContainer = styled.div<{ disabled?: boolean }>`
  width: 72px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 6px 8px;
  border-radius: 8px;
  background-color: ${({ disabled }) => (disabled ? Colors.Neutral15 : Colors.Neutral10)};

  ${TextValue} {
    color: ${({ disabled }) => (disabled ? Colors.Neutral50 : Colors.Neutral90)};
  }
`

export const InputContainer = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 2px 0;
  height: 36px;
  width: 100%;
`
